import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { actionCreators } from 'reduxBits/adBlocker'
import staticFilesUrl from 'utils/staticFilesUrl'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})
let requestBlocked = false
export class _AdBlockDetector extends React.Component {
  constructor() {
    super()
    this.ref = this.ref.bind(this)
  }

  componentDidMount() {
    this.detectAdBlocker(this.adBlockerIframe)
  }

  detectAdBlocker(iframe) {
    try {
      const sendRequest = () => {
        requestBlocked = false
        const r = new XMLHttpRequest()
        r.open('POST', 'https://ib.adnxs.com/ut/v3')
        r.setRequestHeader('Content-type', 'text/plain')
        r.setRequestHeader('X-Is-Test', '1')
        r.addEventListener('error', () => {
          requestBlocked = true
        })
        r.send()
      }

      const isBlocked = (elem) => {
        const elemStyles = getComputedStyle(elem, null)
        const display = elemStyles.getPropertyValue('display')
        const visibility = elemStyles.getPropertyValue('visibility')
        const mozBinding = elemStyles.getPropertyValue('-moz-binding')
        return display === 'none' || visibility === 'hidden' || mozBinding.includes('abp-elemhide')
      }

      const scriptCallback = () => {
        if (iframe.contentWindow) {
          const adBlockerOn = requestBlocked || !iframe.contentWindow.adRequest || isBlocked(iframe)
          const { actions } = this.props
          actions.detectAdBlocker(adBlockerOn)
        }
      }

      const detect = () => {
        if (iframe) {
          sendRequest()
          const frameDoc = iframe.contentDocument
          if (frameDoc) {
            const script = frameDoc.createElement('script')
            script.src = `${staticFilesUrl}assets/scripts/ad-block-detection-script-tag-src.js`
            script.onload = scriptCallback
            script.onerror = scriptCallback
            frameDoc.body.appendChild(script)
          }
        }
      }
      setTimeout(detect, 0)
    } catch (error) {
      /* eslint-disable no-console */
      console.info(`detecting adBlocker failed with ${error}`)
    }
  }

  ref(iframe) {
    this.adBlockerIframe = iframe
  }

  render() {
    const adClasses =
      'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links -adv.js -adv.jpg'
    const style = {
      width: 0,
      height: 0,
      display: 'block',
    }
    return <iframe title="adblockertest" ref={this.ref} className={adClasses} style={style} />
  }
}

_AdBlockDetector.propTypes = {
  actions: PropTypes.object.isRequired,
}

export default connect(
  null,
  mapDispatchToProps,
)(_AdBlockDetector)
